import * as z from "zod";

/**
 * Separate from the dashboard call because it hits Snowflake, which is slow
 * enough that the KPI tiles should not wait on it.
 */
export const getOrderEditingOrderVolumes = {
  name: "getOrderEditingOrderVolumes" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    teamIds: z.array(z.string()).max(2000),
  }),
  output: z.object({
    status: z.enum(["ok", "unavailable"]),
    orderCountsByTeam: z.array(
      z.object({ teamId: z.string(), orderCount: z.number() }),
    ),
  }),
};
